import Core from "@/modules/core/service/Core";

const url = {
    list     : "/api/customer/{0}/recipient",
    create   : "/api/customer/{0}/recipient/create",
    recipient: "/api/customer/recipient/{0}",
};

export default {
    list (customer, success) {
        return Core.method.get(url.list, customer).then ((data) => success(data));
    },

    create (customer, success) {
        return Core.method.get(url.create, customer).then ((data) => success(data));
    },

    findById (customer, success) {
        return Core.method.get(url.recipient, customer).then ((data) => success(data));
    },

    store (recipient, success) {
        if (!recipient.id) {
            Core.method.post(url.list, recipient, recipient.parent.id).then((data) => success(data))
            return;
        }

        return Core.method.put(url.recipient, recipient, recipient.id).then((data) => success(data));
    },
}